<template>
  <div class="card card-2">
    <div class="card-heading">
      <div class="account-erstellen1">{{ $t('log_in') }}</div>

      <div class="registration-detail1">{{ $t('login_to_project_docu_portal') }}</div>
<!--      <div class="img-box1">-->
<!--        <div class="account-h">{{ $t('don\'t_have_a_account_yet') }}</div>-->
<!--        <div class="account-g">-->
<!--          <a href="/register">{{ $t('sign_up_now') }}</a>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="card-body card-body1">
      <!--      <h2 class="title">Registration Info</h2> -->
      <div class="head-img">
        <img alt="image" class="img-responsive" src="@/assets/images/Logo2.png"/>
      </div>
      <form class="form-border-none login" method="post" enctype="multipart/form-data" @submit.prevent="loginFrom()">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label>{{ $t('user_name') }} ( {{ $t('email') }} ) *</label>
            <div class="input-group">
              <input v-model="email"
                :class="{ 'is-invalid': submitted && $v.email.$error }"
                class="input--style-2 form-control"
                placeholder="Max.mustermann@web.de"
                type="email"
                name="email"
                @blur="$v.email.$touch()"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <label>{{ $t('password') }} *</label>
            <div class="input-group">
              <input v-model="password"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
                class="input--style-2 form-control"
                placeholder="*******"
                name="password"
                type="password"
                @blur="$v.password.$touch()"
              />
            </div>
          </div>
        </div>
<!--        <div class="row">-->
<!--          <div class="custom-control custom-checkbox mb-3 custom-check">-->
<!--            <input id="customCheck1" v-model="isSave" class="custom-control-input" type="checkbox"/>-->
<!--            <label class="custom-control-label" for="customCheck1">-->
<!--              {{ $t('save_login_information') }}-->
<!--            </label>-->
<!--          </div>-->
<!--        </div>-->
        <div v-if="msg" class="alert alert-danger alert-dismissible">
          <button class="close" data-dismiss="alert" type="button">&times;</button>
          {{ msg }}
        </div>
        <div class="p-t-30">
          <button class="btn btn--radius-s btn--green1" type="submit" :disabled="loading">
            <span class="spinner-border spinner-grow-sm pmd-spinner mb-1 mr-3 text-dark" role="status" v-if="loading">
              <span class="sr-only">Loading...</span>
            </span>
            {{ $t('login') }}
          </button>
          <div class="al-forget">
            <a class="cursor" @click="forgetPasswordLink">{{ $t('forgot_your_password') }}</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {required, email} from 'vuelidate/lib/validators'
import {mapState} from 'vuex'

export default {
  name: 'login',
  data () {
    return {
      is_error: false,
      msg: '',
      email: '',
      password: '',
      isSave: false,
      submitted: '',
      check: false,
      loading: false
    }
  },
  validations: {
    password: {required},
    email: {required, email}
  },
  methods: {
    forgetPasswordLink () {
      let url = `https://www.projectdocu.net/projects/token.php?username=${this.email || ''}`
      window.open(url, "_blank");
    },

   async loginFrom () {
      this.submitted = true
      this.loading = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
   await axios.post(process.env.VUE_APP_BASE_AMF_URL + `login`, {
          parameters: [this.email, this.password],
          username: this.email,
          password: this.password,
          serviceName: 'ProjectdocuService',
          methodName: 'login',
          deviceid: 'webapp'
        },
        {
          headers: {'Content-Type': 'application/json'}
        })
        .then(response => {
          if (response.status === 200) {
            localStorage.clear()
            this.msg = ''
            if (response.data.errorid !== undefined && response.data.description) {
              this.msg = 'Login fehlgeschlagen'
            } else {
              this.apikey = response.data.PDUserVO.apikey
              this.expire = response.data.PDUserVO.expire
              localStorage.apikey = response.data.PDUserVO.apikey
              localStorage.expire = response.data.PDUserVO.expire
              localStorage.deviceid = 'webapp'
              localStorage.user_id = response.data.PDUserVO.pduserid
              localStorage.sessiontoken = response.data.sessionid
              localStorage.currentUser = response.data.PDUserVO
              localStorage.isSaveData = this.isSave

              this.$store.commit('setCurrentUser', response.data.PDUserVO)

              this.$store.commit('setAuthUser',response.data.PDUserVO)
              if (this.isSave) {
                // localStorage.saveDataEmail = this.email;
                // localStorage.saveDataPassword = this.password;
              }
              this.$router.push('/projects')
            }
          } else {
            this.msg = response.statusText
          }
        })
        .catch(e => {
          this.msg = e
        });
        this.loading = false
    }
  },
  computed: {
    ...mapState({
      currentuser: state => state.current.user
    }),
    isDisabled: function () {
      return this.check
    }
  },
  created () {
    if (localStorage.isSaveData) {
      this.email = localStorage.saveDataEmail
      this.password = localStorage.saveDataPassword
    }
  }
}
</script>
<style scoped>
.cursor{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue